
<mat-spinner class="spinner" *ngIf="(!flagCarga)"></mat-spinner>


<!-- DISPOSITVO 1 CAMA -->
<mat-card class="card" *ngIf="(flagCarga)">

    <mat-card-header class="card-header">
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <mat-card-title><p>Informacion del dispositivo</p>
            <h6 class="estadoOn" *ngIf="(this.flagDatos_1)" >Cama Conectada</h6>
            <h6 class="estadoOff" *ngIf="(!this.flagDatos_1)">Cama Desconectada</h6>
        </mat-card-title>
    </mat-card-header>
    
    <div class="container">


        <!-- <mat-label>CAMA</mat-label> -->



    <table class="tabla" *ngIf="(this.flagDatos_1 && flagCarga)">
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="ocupacion">hotel</mat-icon> Ocupación</h5>
            </td>
            <td>
                <!-- {{ocupActual}} -->
                
                <h5><img *ngIf="(flagOcupacionActual_1)"  class="red-icon" src="./../../../assets/imagenes/iconos/ic_cama_ocupada.png" alt="ocupado"></h5>
                <h5><img *ngIf="(!flagOcupacionActual_1)" class="green-icon" src="./../../../assets/imagenes/iconos/ic_cama_libre.png" alt="libre"></h5>
            </td>
        </tr>
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="temperatua">thermostat</mat-icon> Temperatura</h5>
            </td>
            <td>
                <h5>{{tempActual_1}}°C</h5>
            </td>
        </tr>
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="humedad">water_drop</mat-icon> Humedad</h5> 
            </td>
            <td>
                <h5>{{humeActual_1}}%</h5>
            </td>
        </tr>
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="luminosidad">light_mode</mat-icon> Luminosidad</h5>
            </td>
            <td>
                <h5>{{lumActual_1}}</h5>
            </td>
        </tr>
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="temperatua">emoji_people</mat-icon> Presencia</h5>
            </td>
            <td>
                <h5><mat-icon *ngIf="(flagPresenciaActual_1)"  class="green-icon" aria-hidden="false" aria-label="ocupacion" alt="hay presencia">people_alt</mat-icon> </h5>
                <h5><mat-icon *ngIf="(!flagPresenciaActual_1)" class="red-icon"  aria-hidden="false" aria-label="ocupacion" alt="no hay presencia">group_off</mat-icon> </h5>
                
            </td>
        </tr>
      </table>

    </div>

</mat-card>

<!-- DISPOSITVO 2 SILLÓN -->
<mat-card class="card" *ngIf="(flagCarga)">

    <mat-card-header class="card-header">
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <mat-card-title><p>Informacion del dispositivo</p>
            <h6 class="estadoOn" *ngIf="(this.flagDatos_2)" >Sillón Conectado</h6>
            <h6 class="estadoOff" *ngIf="(!this.flagDatos_2)">Sillón Desconectado</h6>
        </mat-card-title>
    </mat-card-header>
    
    <div class="container">


        <!-- <mat-label>SILLÓN</mat-label> -->
 




    <table class="tabla" *ngIf="(this.flagDatos_2 && flagCarga)">
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="ocupacion">hotel</mat-icon> Ocupación</h5>
            </td>
            <td>
                <!-- {{ocupActual}} -->
                
                <h5><img *ngIf="(flagOcupacionActual_2)"  class="red-icon" src="./../../../assets/imagenes/iconos/ic_sillon_ocupado.png" alt="ocupado"></h5>
                <h5><img *ngIf="(!flagOcupacionActual_2)" class="green-icon" src="./../../../assets/imagenes/iconos/ic_sillon_libre.png" alt="libre"></h5>
            </td>
        </tr>
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="temperatua">thermostat</mat-icon> Temperatura</h5>
            </td>
            <td>
                <h5>{{tempActual_2}}°C</h5>
            </td>
        </tr>
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="humedad">water_drop</mat-icon> Humedad</h5> 
            </td>
            <td>
                <h5>{{humeActual_2}}%</h5>
            </td>
        </tr>
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="luminosidad">light_mode</mat-icon> Luminosidad</h5>
            </td>
            <td>
                <h5>{{lumActual_2}}</h5>
            </td>
        </tr>
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="temperatua">emoji_people</mat-icon> Presencia</h5>
            </td>
            <td>
                <h5><mat-icon *ngIf="(flagPresenciaActual_2)"  class="green-icon" aria-hidden="false" aria-label="ocupacion" alt="hay presencia">people_alt</mat-icon> </h5>
                <h5><mat-icon *ngIf="(!flagPresenciaActual_2)" class="red-icon"  aria-hidden="false" aria-label="ocupacion" alt="no hay presencia">group_off</mat-icon> </h5>
                
            </td>
        </tr>
      </table>

    </div>

</mat-card>

<!-- DISPOSITVO 3 FRIGORÍFICO -->
<mat-card class="card" *ngIf="(flagCarga)">

    <mat-card-header class="card-header">
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <mat-card-title><p>Informacion del dispositivo</p>
            <h6 class="estadoOn" *ngIf="(this.flagDatos_3)" >Frigorífico Conectado</h6>
            <h6 class="estadoOff" *ngIf="(!this.flagDatos_3)">Frigorífico Desconectado</h6>
        </mat-card-title>
    </mat-card-header>
    
    <div class="container">


        <!-- <mat-label>FRIGORÍFICO</mat-label> -->



    <table class="tabla" *ngIf="(this.flagDatos_3 && flagCarga)">
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="ocupacion">kitchen</mat-icon> Estado</h5>
            </td>
            <td>
                <!-- {{ocupActual}} -->
                
                <h5><img *ngIf="(flagEstadoActual_3)"  class="red-icon" src="./../../../assets/imagenes/iconos/ic_fridge_open_b.png" alt="abierto"></h5>
                <h5><img *ngIf="(!flagEstadoActual_3)" class="green-icon" src="./../../../assets/imagenes/iconos/ic_fridge_close_b.png" alt="cerrado"></h5>
            </td>
        </tr>
        <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="temperatua">emoji_people</mat-icon> Presencia</h5>
            </td>
            <td>
                <!-- <h5><img *ngIf="(estadoPresencia_3)"  class="icono" src="./../../../assets/imagenes/iconos/ic_fridge_open.png" alt="hay presencia"></h5> -->
                <!-- <h5><img *ngIf="(!estadoPresencia_3)" class="icono" src="./../../../assets/imagenes/iconos/ic_fridge_close.png" alt="no hay presencia"></h5> -->
                <h5><mat-icon *ngIf="(flagPresenciaActual_3)"  class="green-icon" aria-hidden="false" aria-label="ocupacion" alt="hay presencia">people_alt</mat-icon> </h5>
                <h5><mat-icon *ngIf="(!flagPresenciaActual_3)" class="red-icon"  aria-hidden="false" aria-label="ocupacion" alt="no hay presencia">group_off</mat-icon> </h5>
                
            </td>
        </tr>
        <!-- <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="humedad">water_drop</mat-icon> Humedad</h5> 
            </td>
            <td>
                <h5>{{humeActual}}%</h5>
            </td>
        </tr> -->
        <!-- <tr>
            <td>

            </td>
            <td class="td">
                <h5><mat-icon class="icon" aria-hidden="false" aria-label="luminosidad">light_mode</mat-icon> Luminosidad</h5>
            </td>
            <td>
                <h5>{{lumActual}}</h5>
            </td>
        </tr> -->
      </table>

    </div>

</mat-card>





<!-- <div class="button-container">
    <button class="buttonActualizar" mat-raised-button color="accent" (click)="actualizar()">
      <mat-icon>refresh</mat-icon>
  </button>
  <div> -->